import React, { Fragment, useEffect, useRef, useState } from "react";
import { getFileExtensionIconClass } from "./utils";
import { GdkProgressBar } from "@gdk/progress-bar";

export default function FileUploadSubmitting({
    selectedFiles,
    onFileUploadSubmit = () => { },
    fileUploadParameters,
    progress,
    displayParameters
}) {
    const progressBar = useRef();

    useEffect(() => {
        onFileUploadSubmit(selectedFiles);
    }, []);

    useEffect(() => {
        if (progress && !progressBar.current) {
            progressBar.current = new GdkProgressBar({
                "content": "#file-upload-progress",
                "setInitialValue": `${progress}`,
            });
        }

        progressBar.current?.setValue(progress);
    }, [progress]);

    return (
        <div className="drop doc-status-wrapper">
            <div className="font--center padding-top">
                {displayParameters.submittingTopText}
                {displayParameters.submittingSubtext}
            </div>
            {progress > 0 &&
                <div className="container-padding">
                    <div id="file-upload-progress" className="progress-wrapper">
                        <progress max="100" value={progress}>{progress}%</progress>
                        <label>{progress}%</label>
                    </div>
                </div>
            }
            <div className="doc-upload-status container-padding margin-bottom">
                {displayParameters.submittingHeader}
                {displayParameters.showColumnHeaders &&
                    <div className="doc-labels padding-bottom hidden-sm hidden-md">
                        <div className="column col-lg-6">File Name</div>
                        {fileUploadParameters.uploadCategories?.length > 0 && <div className="column col-lg-6">Category</div>}
                    </div>
                }
                <div className="upload-container">
                    {Array.from(selectedFiles).map((file) => (
                        <Fragment key={file.name}>
                            {displayParameters.strokeSeparator && <hr />}
                            <div key={`${file.name}-selected-file-upload-container`}>
                                <div className="doc-upload-files column col-lg-6">
                                    <span className={`img-icon ${getFileExtensionIconClass(file.name)} hidden-sm hidden-md`} />
                                </div>
                                <div className="status-name column col-lg-6">
                                    {file.name}
                                </div>
                                {fileUploadParameters.uploadCategories?.length > 0 &&
                                    <div className="status-category column col-lg-6">
                                        {file.selectedUploadCategory}
                                    </div>
                                }
                                <div className="status-outcome column col-lg-6">
                                    <span
                                        id="your-loader-id-1"
                                        className="loader"
                                        aria-label="Please wait, it is loading"
                                    />
                                </div>
                            </div>
                        </Fragment>
                    ))}
                </div>
            </div>
        </div>
    );
};
